import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import classnames from 'classnames'
import listensToClickOutside from 'react-onclickoutside';
import isLoggedIn from '../../utils'
import {
  doLogoutUser,

  openLoginFormRequest,
  openLoginFormSuccess,
  openLoginFormFailure,

  closeLoginFormRequest,
  closeLoginFormSuccess,
  closeLoginFormFailure,

  openSignupFormRequest,
  openSignupFormSuccess,
  openSignupFormFailure,

  closeSignupFormRequest,
  closeSignupFormSuccess,
  closeSignupFormFailure
} from '../../actions'
import SearchWidget from './Search'


@listensToClickOutside
class SignupWidget extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }

  handleClickOutside = (event) => {
    this.setState({ isOpen: false })
  };

  open = (event) => {
    event.preventDefault();
    this.setState({ isOpen: true })
  }

  close = (event) => {
    event.preventDefault();
    this.setState({ isOpen: false })
  }

  toggle = (event) => {
    event.preventDefault();
    this.setState({ isOpen: !this.state.isOpen})
  }

  render() {
    const {browser, openSignupFormRequest, openLoginFormRequest} = this.props
    const popup = (
      <div className="headerSignupWidgetPopup">
        <div className="headerSignupWidgetPopupItem">
          <a href="#" className="button"
              onClick={(e) => { e.preventDefault(); openSignupFormRequest() }}>
              Sign up</a>
        </div>
        <div className="headerSignupWidgetPopupItem">
          <a href="#" className="button"
              onClick={(e) => { e.preventDefault(); openLoginFormRequest() }}>
              Log in
          </a>
        </div>
      </div>
    )

    if (browser.lessThan.phablet) {
      return (
        <div className="headerSignupWidget">
          <a href="#" onClick={this.toggle} className="signup">Sign up</a>
          {(this.state.isOpen) ? popup : ''}
        </div>
      )
    } else {
      return <a href="#" className="signup"
              onClick={(e) => { e.preventDefault(); openSignupFormRequest() }}>
              Sign up</a>
    }
  }
}


@listensToClickOutside
class ShareWidget extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }

  handleClickOutside = (event) => {
    this.setState({ isOpen: false })
  };

  open = (event) => {
    event.preventDefault();
    this.setState({ isOpen: true })
  }

  close = (event) => {
    event.preventDefault();
    this.setState({ isOpen: false })
  }

  toggle = (event) => {
    event.preventDefault();
    this.setState({ isOpen: !this.state.isOpen})
  }

  render() {
    let popup = (
      <div className="headerShareWidgetPopup">
        <div class="fb-share-button" data-href="https://worldwidewomen.co" data-layout="button_count" data-size="small"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fworldwidewomen.co%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore"><i className="fa fa-2x fa-facebook"></i></a></div>
        <div><a href="https://twitter.com/intent/tweet?text=WorldWideWomen%20is%20the%20first-ever%20global%20online%20resource%20center%20for%20women%20and%20girls.&source=" target="_blank"><i className="fa fa-2x fa-twitter"></i></a></div>
        <div><a href="mailto:?subject=Check%20out%20the%20WorldWideWomen%20website&body=I%20wanted%20to%20show%20you%20this%20amazing%20website%20called%20WorldWideWomen.%20It's%20the%20first-ever%20online%20resource%20center%20for%20women%20and%20girls%20around%20the%20world.%20Join%20me%20in%20helping%20them%20create%20a%20global%20community%20and%20network%20for%20women%20by%20signing%20up%20on%20their%20website%20at%20www.worldwidewomen.co."><i className="fa fa-2x fa-envelope-o"></i></a></div>
      </div>
    )
    return (
      <div className="headerShareWidget">
        {(true && this.state.isOpen) ? popup : ''}
        <a href="#" onClick={this.toggle} className="button">{( this.props.btnLabel ) ? this.props.btnLabel : 'Share'}</a><div className="authlinks-circleWrapper"><img src="/images/eyebrow_bullet.jpg" /></div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    browser: state.browser,
    user: state.auth.user,
  }
}

@connect(mapStateToProps, {
  doLogoutUser,

  openLoginFormRequest,
  openSignupFormRequest
})
class AuthLinks extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoggedIn: false
    }
  }

  logoutUser = event => {
    event.preventDefault()
    this.props.doLogoutUser()
  }

  componentWillReceiveProps(nextProps) {
    let { browser, user } = nextProps
    this.setState({
      isLoggedIn: Boolean(user)
    })
  }

  componentDidMount() {
    let { browser, user } = this.props
    this.setState({
      isLoggedIn: Boolean(user)
    })
  }

  render() {
    const { browser, user } = this.props

    let recommend = '';

    recommend = <li key="hal-reccommend"><Link className="button" to="/my/recommend">Add resource</Link><div className="authlinks-circleWrapper"><img src="/images/eyebrow_bullet.jpg" /></div></li>
    let recommend_anonymous = <li key="hal-reccommend">
      <a onClick={(e) => { this.props.openSignupFormRequest({next: "/my/recommend"})}} href="#" className="button">Add resource</a>
        <div className="authlinks-circleWrapper"><img src="/images/eyebrow_bullet.jpg" /></div>
        </li>

    let shareWidget = <li key="hal-share"><ShareWidget /></li>

    let login = <li key="hal-login">
      <a className="button" href="#" onClick={(e) => { this.props.openLoginFormRequest() }}>
        Log in</a>
        <div className="authlinks-circleWrapper"><img src="/images/eyebrow_bullet.jpg" /></div>
    </li>

    let loginIcon = <li key="hal-loginIcon">
      <a className="button" href="#" onClick={(e) => { this.props.openLoginFormRequest() }}>
        <i className="fa fa-sign-in"></i>
      </a>
    </li>

    let logout = <li className="logout" key="hal-logout"><a onClick={this.logoutUser}
                        className="button" href="#">Logout</a></li>

    let logoutIcon = <li key="hal-logoutIcon"><a onClick={this.logoutUser}
                        className="button" href="#"><i className="fa fa-sign-out"></i></a></li>

    let signup = <li key="hal-signup">
      <SignupWidget openSignupFormRequest={this.props.openSignupFormRequest}
                    openLoginFormRequest={this.props.openLoginFormRequest}
                    browser={browser} />
    </li>

    let searchWidget = <li key="hal-searchWidget"><SearchWidget /></li>

    let profile = <li key="hal-profile"><Link to="/my" className="button">My Profile</Link><div className="authlinks-circleWrapper"><img src="/images/eyebrow_bullet.jpg" /></div></li>

    let mylisting = ''

    let profileIcon = <li key="hal-profileIcon"><Link to="/my" className="button"><i className="fa fa-user"></i></Link><div className="authlinks-circleWrapper"><img src="/images/eyebrow_bullet.jpg" /></div></li>

    if (browser.lessThan.phablet) {
      shareWidget = <li key="hal-share"><ShareWidget btnLabel={<i className="fa fa-share-alt"></i>}/></li>
      profile = profileIcon
      login = loginIcon
    }


    let items = [
      recommend_anonymous,
      shareWidget,
      signup,
      searchWidget
    ]

    if (browser.greaterThan.mobile) {
      items = [
        recommend_anonymous,
        shareWidget,
        login,
        signup
      ]
    }


    if (this.state.isLoggedIn) {
      const orgClaim = user.organizationClaim
      if (orgClaim && orgClaim.organization) {
        mylisting = [ <li key="hal-mylisting"><Link to={`/organizations/${orgClaim.organization}`} className="button">My Listing</Link><div className="authlinks-circleWrapper"><img src="/images/eyebrow_bullet.jpg" /></div></li>]

        // Since the user already has a claimed orgs
        // don't show recommend to list links
        recommend = ''
      }

      items = [
        mylisting,
        recommend,
        shareWidget,
        profile,
        logoutIcon,
        searchWidget
      ]

      if (browser.greaterThan.desktop) {
        items = [
          mylisting,
          recommend,
          shareWidget,
          profile,
          logout,
      ]
      }
    }

    return (
      <ul className="headerAuthLinks">
        {items}
      </ul>
    )
  }
}

export default AuthLinks



// WEBPACK FOOTER //
// ./src/components/header/Auth.jsx